import { SxProps, Theme } from "@mui/material";

export const filterPillSx: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.75,
  borderRadius: 2,
  bgcolor: "action.hover",
  pl: 1,
  pr: 0.25,
  py: 0.5,
};
